/** @format */

import React, {useContext, useState} from 'react';
import {capitalize} from 'frontier/ds/quoter/functions/format';
import withDesignHandler from 'frontier/ds/quoter/hoc/with_design_handler';
import {Button, IconButton, Input} from '@sttark/design-system';
import {QuoteContext} from 'frontier-quoter';

import './uploaded_designs_orders.sass';
import {ConditionalButton} from 'frontier-utilities';

import SingleUploadedDesignsOrder from 'frontier/ds/quoter/single_uploaded_designs_order';

export default function UploadedDesignsOrders(props) {
    const ctx = useContext(QuoteContext);
    let designsOrders = props.designsOrders.filter(({design}) => {
        // When this is front/back or duplex, the linked design print_sequence will be 2
        // This allows us to filter it and only show the first design
        return parseInt(design.print_sequence) === 1;
    });

    return designsOrders.map((designOrder, index) => (
        <SingleUploadedDesignsOrder
            index={index}
            key={`${designOrder.id}_${index}`}
            {...designOrder}
            onDesignUpdate={props.onDesignUpdate}
            designsOrders={props.designsOrders}
            onDelete={props.onDeleteDesign.bind(
                this,
                designOrder.id,
                designOrder.customer_filestack_id
            )}
            onClickAddFiles={props.onClickAddFiles}
        />
    ));
}
